import React from "react"
import {IonLabel, IonListHeader} from "@ionic/react";

type props = {
    title:    string
    subTitle: string
    right?:   string
}

const ItemSegmentListHeader: React.FC<props> = ({title, subTitle, right}) => {

    return (
        <IonListHeader lines="inset">
            <IonLabel>
                {title}
                <p style={{'lineHeight': 1.4}}>
                    {subTitle}
                    {right && <span className="ion-float-right ion-padding-end">
                        {right}
                    </span>}
                </p>
            </IonLabel>
        </IonListHeader>
    )
}

export default ItemSegmentListHeader